export default function auth({ to, next, store }) {
  store.dispatch("auth/getAuthUser").then(() => {

  })
  const loginQuery = { path: "/login", query: { redirect: to.fullPath } };

  if (!store.getters["auth/authUser"]) {
      if (!store.getters["auth/authUser"]) next(loginQuery);
      else next();

  } else {
    next();
  }
}